import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { QuestionMarkCircleIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { Mixpanel } from '../../../services/Mixpanel';
import SidebarItem from './SidebarItem';

function SupportMenu({ isExpanded }) {
  const menuItems = [
    { label: 'Help Center', href: 'https://support.diffit.me' },
    { label: 'Professional Development', href: 'https://web.diffit.me/professional-development' },
    { label: 'About Diffit', href: 'https://web.diffit.me' },
    { label: 'Contact Us', href: 'https://support.diffit.me/hc/en-us/requests/new' },
  ];

  return (
    <Menu as='div' className='relative'>
      {({ open }) => (
        <>
          <SidebarItem
            icon={QuestionMarkCircleIcon}
            label='Support'
            isExpanded={isExpanded}
            root={Menu.Button}
            tooltipDisabled={open}>
            {isExpanded && (
              <ChevronDownIcon className='ml-auto h-4 w-4 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity' />
            )}
          </SidebarItem>
          <Transition
            as={Fragment}
            enter='transition ease-out duration-100'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='transition ease-in duration-75'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'>
            <Menu.Items
              className={`absolute z-50 rounded-xl bg-white p-1.5 shadow-lg border border-gray-200 focus:outline-none ${
                isExpanded ? 'w-60 top-full left-0 mt-1' : 'w-56 left-full top-0 ml-2'
              }`}>
              {menuItems.map((item) => (
                <Menu.Item key={item.label}>
                  {({ active }) => (
                    <a
                      href={item.href}
                      target='_blank'
                      rel='noopener noreferrer'
                      onClick={() => Mixpanel.track('Sidebar click', { item: item.label })}
                      className={`block w-full px-3 py-2 rounded-lg transition-colors text-sm ${
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                      }`}>
                      {item.label}
                    </a>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}

export default SupportMenu;
